export default {
  "content": "<path fill=\"#BBB\" d=\"M15.753 14.719l-4.187-4.188c.906-1.11 1.406-2.506 1.406-4.031a6.5 6.5 0 00-6.5-6.5C2.882 0 0 2.91 0 6.5S2.91 13 6.472 13a6.462 6.462 0 004.031-1.408l4.188 4.188c.175.148.368.22.559.22a.75.75 0 00.53-.22.73.73 0 00-.027-1.061zM1.5 6.5c0-2.757 2.243-5 5-5s5 2.243 5 5-2.243 5-5 5-5-2.244-5-5z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "none",
    "viewBox": "0 0 16 16"
  }
};